module.exports = __webpack_public_path__ + "img/sibregion.d8523cfd.svg";